<a href={attrs.link} target="_blank"><slot></slot></a>

<script>
export let attrs;
</script>